import PropTypes from 'prop-types'

export const propTypes = {
  description: PropTypes.string
}

export const defaultProps = {
  description: 'Page loading'
}
